import { render, staticRenderFns } from "./usualProblem.vue?vue&type=template&id=71155898&scoped=true"
import script from "./usualProblem.vue?vue&type=script&lang=js"
export * from "./usualProblem.vue?vue&type=script&lang=js"
import style0 from "./usualProblem.vue?vue&type=style&index=0&id=71155898&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71155898",
  null
  
)

export default component.exports